import * as PropTypes from 'prop-types';
import React from 'react';

import './ProgressLine.scss';

const ProgressLine = ({ timeAnimate }) => {
	return (
		<div className='ProgressLine'>
			<svg width='52' height='52'>
				<circle cx='26' cy='26' r='24' style={{ animationDuration: timeAnimate + 's' }} />
			</svg>
		</div>
	);
};

ProgressLine.propTypes = {
	timeAnimate: PropTypes.number,
};

export default ProgressLine;
